export function validationTriggerExpression(basePath: string, requiredPaths: string[]): string {
  if (requiredPaths.length === 0) return `\`${basePath}.\${expandedIndex}\` as never`

  const paths = requiredPaths.map((path) => `\`${basePath}.\${expandedIndex}.${path}\``).join(', ')
  return `[${paths}] as never`
}
